const locale = {
  // Applications: 'Modullar',
  Applications: 'Arizalar',
  EXAMPLE: 'Sahifa',
  HR: 'HR',
  ADMIN: 'ADMIN',
  Academy: 'Kurslar',
  Profile: 'Profil',
  Continue: 'Davom ettirish',
  Settings: 'Sozlamalar',
  Export: 'Eksport',
  CompanyNews: 'Kompaniya yangiliklari',
  Employees: 'Xodimlar',
  ProjectsManagement: 'Loyihalarni boshqarish',
  Projects: 'Loyihalar',
  Calendar: 'Kalendar',
  Chat: 'Chat',
  Mail: 'Pochta',
  SCRUMBOARD: 'SCRUMBOARD',
  Structure: 'Struktura',
  Blanks: 'Shakllar',
  Skud: 'Ish vaqtini hisobi',
  MySkud: 'Mening vaqtim',
  Departments: "Bo'limlar",
  Users: 'Foydalanuvchilar',
  Roles: 'Rollar',
  StaffTable: 'Xodimlar jadvali',
  SkudEmployees: "Bo'ysunuvchi xodimlari",
  SkudReport: 'SKUD. Statistika',
  Reservation: 'Bron qilish',
  MyCalendar: 'Mening kalendarim',
  References: "Ma'lumotnomalar",
  Support: 'Yordam',
  Presentations: 'Taqdimotlar',
  Main: 'Bosh sahifa',
  Basic: 'Asosiy',
  Work: 'Ish',
  Useful: 'Foydali',
  Administration: 'Boshqaruv',
  HumanResources: 'Xodimlar bilan ishlash',
  HelpDesk: 'Yordam xizmati',
  HelpCenter: 'Yordam markazi',
  Feedback: 'Qayta aloqa',
  Documents: 'Hujjatlar',
  MyUzinfocom: 'Mening Uzinfocomim',
  Map: 'Xarita',
  Maps: 'Xaritalar',
  DownloadApp: 'Ilovani yuklab olish',
  Logs: 'Loglar',
  ClaimExecutors: "So'rovlar ijrochilari",
  ClaimsProcessing: "So'rovlarni qayta ishlash",
  InternalDocuments: 'Ichki hujjatlar',
  Claims: "So'rovlar",
  DailyAttendances: 'Bir kunlik davomatlari',
  AbsenceAsks: 'Ish safarlari va dam olishlar',
  UsefulLinks: 'Foydali havolalar',
  Workload: 'Ish yuki',
  VisitBooking: 'Uchrashuv qabuliga yozilish',
  TopManagers: 'Rahbariyat',
  Appointments: 'Qabuliga yozilishlari',
  VideoConferences: 'Videokonferentsiyalar',
  Values: 'Qadriyatlar',
  MemoryAndHonors: 'Xotira va hurmat',
  Skills: "Ko'nikmalar",
  Faithful: 'Fidoiylar',
  ElectronMail: 'Elektron pochta',
  MyUzAtom: 'Mening UzAtom',
  TemplatesConstructor: 'Shablonlar konstruktori',
  TemplatesManagement: 'Shablonlarni boshqarish',
  IncomingDocuments: 'Kirish hujjatlari',
  Executed: 'Bajarilgan',
  PendingExecution: 'Kutilmoqda',
  InExecution: 'Ijroda',
  MyApplications: 'Mening arizalarim',
  Staff: 'Xodimlar',
  PrintDocuments: 'Hujjatlarni chop etish',
  DocumentTemplateExecutors: 'Hujjat shablonlari ijrochilar',
  DocumentExecutors: 'Hujjat ijrochilar',
  Report: 'Hisobot',
  ProjectsManagement: 'Loyihalar boshqaruvi',
  MyDocuments: 'Mening hujjatlarim',
  DepartmentsReport: 'Bir oylik hisobot',
  DocumentChecking: 'Hujjat tekshirishi',
  Fulfilled: 'Bajarilganlar',
  Dashboard: 'Dashbord',
  MyDrive: 'Mening diskim',
  ServiceDesk: 'Texnik yordam',
  BlocksDailyReport: "Bloklar bo'yicha kunlik hisoboti",
  SkudStatistics: 'SKUD. Statistika',
  LocalNormativeActs: 'Mahalliy normativ hujjatlar',
  PendingSignature: 'Imzoda',
  Signed: 'Imzolangan',
  Rejected: 'Rad etilgan',
  Archived: 'Arxivlangan',
  Archive: 'Arxiv',
  InternalWorkflow: 'Ichki hujjat aylanishi',
  AttendaceReport: 'Davomat hisobotі',
  InternalWorkflow2: 'Ichki hujjat aylanishi(2)',
  AttendaceReportTop: 'TOP rahbariyat tashriflari bo‘yicha hisobot',
  MyCalendarBeta: 'Mening kalendarim (beta)',
  OutgoingDocuments: 'Chiqish hujjatlari',
  CreateDocument: 'Hujjat yaratish',
  AttendanceReport: 'Davomat hisoboti',
};

export default locale;
